var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tab-item',{attrs:{"value":_vm.NEWS.value}},[_c('about-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }